// extracted by mini-css-extract-plugin
export var root = "Policy-module--root--viR5L";
export var section = "Policy-module--section--j2G3l";